export default {
      id: "ic-display-block-usage",
      viewBox: "0 0 108 34",
      url: "../dist/images/" + "sprite.svg#ic-display-block-usage",
      toString: function () {
        return this.url;
      }
    }